__turbopack_context__.v({
  "date": "ns1Mzq_date",
  "updatedDate": "ns1Mzq_updatedDate",
});
